export default __webpack_public_path__ + "static/media/JoeyChestnutHeadline.f306a9b8.png";